import { PAGE_PROP, SEARCH_PROP, TAB_PROP } from '@Utils/constants';
import { SetURLSearchParams } from 'react-router-dom';

// TODO: Fix when breadcrumbs are used
// @ts-expect-error
const _fillPreviousBreadcrumb = (route: string, state: any) => {
  route += '?';
  if (state?.tab) {
    route += `${TAB_PROP}=${state.tab}`;
    if (state?.searchParam || state?.page) {
      route += `&`;
    }
  }
  if (state?.searchParam) {
    route += `${SEARCH_PROP}=${state.searchParam}`;
    if (state?.page) {
      route += `&`;
    }
  }
  if (state?.page) {
    route += `${PAGE_PROP}=${state.page}`;
  }
  return route;
};

export const fillSearchParams = (
  setSearchParams: SetURLSearchParams,
  rawParams: Record<string, string | number | undefined>,
) => {
  const params: Record<string, string> = {};

  for (const [key, value] of Object.entries(rawParams)) {
    if (value?.toString()) {
      params[key] = encodeURI(value.toString());
    }
  }
  setSearchParams(params);
};
